const config = {
  url: '/galleries',
  title: 'Галереи',
  endpoint: '/admin-search?filter=galleries',
  type: 'table',
  getUrl: id => `/gallery/${id}`,
  getApiUrl: id => `/galleries/${id}`,
  search: true,
  key: 'galleries',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
